import React, { useEffect } from 'react';
import { Link, useLocation, Navigate } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';
import { openCookieSettings } from '../utils/consent';
import { getPolicyByPath, policyList } from '../data/policies';
import './PolicyPage.css';

function PolicyPage() {
  const { pathname } = useLocation();
  const policy = getPolicyByPath(pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (!policy) {
    return <Navigate to="/" replace />;
  }

  const otherPolicies = policyList.filter((p) => p.path !== policy.path);

  return (
    <div className="policy-page">
      <SEO />
      <PageHero
        breadcrumbs={[{ name: policy.title, path: policy.path }]}
        title={policy.title}
        text={`Last updated: ${policy.lastUpdated}`}
      />

      <section className="section section-white">
        <div className="container policy-content">
          <p className="policy-intro">{policy.intro}</p>

          {policy.path === '/cookie-policy' && (
            <div className="policy-cookie-box">
              <div>
                <h2>Your cookie preferences</h2>
                <p>Review or change which cookies you allow on this website at any time.</p>
              </div>
              <button type="button" className="btn btn-primary" onClick={openCookieSettings}>
                Change cookie settings
              </button>
            </div>
          )}

          {policy.sections.map((section) => (
            <div key={section.heading} className="policy-section">
              <h2 className="policy-section-title">{section.heading}</h2>
              {section.paragraphs?.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
              {section.bullets?.length > 0 && (
                <ul className="policy-list">
                  {section.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div className="policy-related">
            <h2 className="policy-section-title">Related Policies</h2>
            <ul className="policy-related-links">
              {otherPolicies.map((p) => (
                <li key={p.path}>
                  <Link to={p.path}>{p.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PolicyPage;
